<template>
  <div v-if="pcw">
    <h1>PCW</h1>
    <v-btn :to="{name:'pcws'}">
      <v-icon>chevron_left</v-icon>Pcws
    </v-btn>
    <h3>Information</h3>
    <table>
      <tr>
        <th>Id</th>
        <td>{{pcw.pcwId}}</td>
      </tr>
      <tr>
        <th>Client</th>
        <td>{{pcw.client}}</td>
      </tr>
      <tr>
        <th>Matter</th>
        <td>{{pcw.matter}}</td>
      </tr>
      <tr>
        <th>Category code</th>
        <td>{{pcw.categoryCode}}</td>
      </tr>
      <tr>
        <th>Fee earner</th>
        <td>{{pcw.feeEarnerCode}}</td>
      </tr>
      <tr>
        <th>Branch</th>
        <td>{{pcw.branchCode}}</td>
      </tr>
      <tr>
        <th>Reference</th>
        <td>
          <router-link
            v-if="pcw.oldId > 0"
            :to="{name:'operator', params:{id:pcw.oldId}}"
          >{{pcw.oldId}}</router-link>
        </td>
      </tr>
    </table>
    <h3>Dates</h3>
    <table>
      <tr>
        <th>Completion date</th>
        <td>{{pcw.completionDate | formatDate}}</td>
      </tr>
      <tr>
        <th>Tally date</th>
        <td>{{pcw.tallyDate | formatDate}}</td>
      </tr>
      <tr>
        <th>File date</th>
        <td>{{pcw.fileDate | formatDate}}</td>
      </tr>
      <tr>
        <th>Label L</th>
        <td>{{pcw.labelL}}</td>
      </tr>
      <tr>
        <th>Dead id</th>
        <td>{{pcw.deadId}}</td>
      </tr>
      <tr>
        <th>Dead date</th>
        <td>{{pcw.deadDate | formatDate}}</td>
      </tr>
      <tr>
        <th>Deeds date</th>
        <td>{{pcw.deedsDate | formatDate}}</td>
      </tr>
      <tr>
        <th>Deeds Id</th>
        <td>{{pcw.deedsId}}</td>
      </tr>
      <tr>
        <th>Deeds L</th>
        <td>{{pcw.deedsL}}</td>
      </tr>
      <tr>
        <th>Stamp out date</th>
        <td>{{pcw.stOutDate | formatDate}}</td>
      </tr>
      <tr>
        <th>Stamp in date</th>
        <td>{{pcw.stInDate | formatDate}}</td>
      </tr>
      <tr>
        <th>Stamp in date</th>
        <td>{{pcw.stInDate | formatDate}}</td>
      </tr>
      <tr>
        <th>Stamp L</th>
        <td>{{pcw.stL}}</td>
      </tr>
      <tr>
        <th>HMLR out date</th>
        <td>{{pcw.hmOutDate | formatDate}}</td>
      </tr>
      <tr>
        <th>HMLR in date</th>
        <td>{{pcw.hmInDate | formatDate}}</td>
      </tr>
      <tr>
        <th>HMLR L</th>
        <td>{{pcw.hmL}}</td>
      </tr>
      <tr>
        <th>HMLR OK date</th>
        <td>{{pcw.hmOkDate | formatDate}}</td>
      </tr>
      <tr>
        <th>HMLR cancelled date</th>
        <td>{{pcw.hmCanDate | formatDate}}</td>
      </tr>
      <tr>
        <th>Deeds out date</th>
        <td>{{pcw.deedsOutDate | formatDate}}</td>
      </tr>
      <tr>
        <th>Deeds acknowledge date</th>
        <td>{{pcw.deedsAckDate | formatDate}}</td>
      </tr>
      <tr>
        <th>Cmp L</th>
        <td>{{pcw.cmpL}}</td>
      </tr>
      <tr>
        <th>Cmp in date</th>
        <td>{{pcw.cmpInDate | formatDate}}</td>
      </tr>
      <tr>
        <th>Cmp res date</th>
        <td>{{pcw.cmpResDate | formatDate}}</td>
      </tr>
      <tr>
        <th>Deeds ret date</th>
        <td>{{pcw.deedsRetL}}</td>
      </tr>
      <tr>
        <th>F to date</th>
        <td>{{pcw.fToId}}</td>
      </tr>
      <tr>
        <th>F out date</th>
        <td>{{pcw.fOutDate | formatDate}}</td>
      </tr>
      <tr>
        <th>F in date</th>
        <td>{{pcw.fInDate}}</td>
      </tr>
      <tr>
        <th>Abortive</th>
        <td>{{pcw.abortive}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Pcw",
  metaInfo() {
    return {
      title: "Pcw",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return { pcw: null };
  },
  methods: {
    fetchPcw() {
      nbmlaw
        .get(`/cors/admin/file/pcws/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data);
          this.pcw = response.data;
        });
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchPcw();
      }
    }
  }
};
</script>

<style>
</style>
